import { VantifyProxyResponse, vantifyRequest } from 'integrations-vantify-api-client';
import { VantifyAuth, VantifyQuery } from '../common';
import { JobGroupListResponse } from './types';

/**
 * Get job groups (categories)
 * Fetches job groups data with default limit of 500
 */
export async function getJobGroups(
  auth: VantifyAuth,
  query?: VantifyQuery
): Promise<VantifyProxyResponse<JobGroupListResponse>> {
  const DEFAULT_LIMIT = 500;

  return await vantifyRequest<JobGroupListResponse>({
    method: 'GET',
    pathname: 'jobgroups',
    query: {
      fetchHierarchy: false,
      active: 1,
      limit: DEFAULT_LIMIT,
      ...query,
    },
    auth,
  });
}
